import './carousel.js';
//import './html.js';
import './navigation.js';
import './search.js';
import './admissions.js';
